module.exports = __webpack_public_path__ + "img/link-button.ca9e858b.svg";